<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-jump-rope`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 3a1 1 0 011 1v22a1 1 0 01-1 1h-3v7.818c0 3.373 2.39 6.058 5.297 6.178L17.5 41c2.929 0 5.386-2.608 5.496-5.948l.004-.234V12.792C23 7.456 26.717 3 31.5 3c4.699 0 8.37 4.301 8.497 9.512l.003.28V23h3a1 1 0 011 1v20a1 1 0 01-1 1H33a1 1 0 01-1-1V24a1 1 0 011-1h3V12.792C36 9.52 33.897 7 31.5 7c-2.335 0-4.392 2.393-4.496 5.542l-.004.25v22.026C27 40.405 22.787 45 17.5 45c-5.198 0-9.357-4.441-9.496-9.899L8 34.818V27H5a1 1 0 01-1-1V4a1 1 0 011-1h10zm25 24h-4v14h4V27zM8 7h4v16H8V7z"/></svg>
</template>
<script>

export default {
  name: 'IconJumpRope',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
